import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { AdminFeedbackRequest } from '@fois-utsavvoice/shared';
import { listFeedbackRequests } from '../api/admin.js';
import { useAuth } from '../auth/AuthContext.js';
import { AdminNav } from '../components/AdminNav.js';
import { PageShell } from '../components/PageShell.js';

export function AdminHomePage() {
  const auth = useAuth();
  const [items, setItems] = useState<AdminFeedbackRequest[]>([]);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (!auth.tokens) {
      return;
    }
    listFeedbackRequests(auth.tokens.idToken)
      .then((page) => setItems(page.items))
      .catch(() => setError('Feedback requests could not be loaded.'));
  }, [auth.tokens]);

  return (
    <PageShell>
      <AdminNav />
      <section className="card">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="heading-xl text-crimson">Feedback requests</h1>
          <Link className="btn-primary" to="/admin/requests/new">
            Create feedback request
          </Link>
        </div>
        <p className="mt-3 text-charcoal">
          Signed in as {auth.email ?? auth.subject ?? 'administrator'}. Create a unique customer
          link for each Shopify or manual order.
        </p>
        {error ? (
          <p className="mt-4 text-sm font-semibold text-crimson" role="alert">
            {error}
          </p>
        ) : null}
        <div className="mt-6 overflow-x-auto">
          <table className="min-w-full text-left text-sm">
            <thead>
              <tr className="border-b border-linen">
                <th className="py-2 pr-4">Order</th>
                <th className="py-2 pr-4">Product</th>
                <th className="py-2 pr-4">Status</th>
                <th className="py-2 pr-4">Created</th>
                <th className="py-2"> </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.requestId} className="border-b border-linen">
                  <td className="py-3 pr-4">{item.orderReference}</td>
                  <td className="py-3 pr-4">{item.productName}</td>
                  <td className="py-3 pr-4">{item.status}</td>
                  <td className="py-3 pr-4">{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td className="py-3">
                    <Link
                      className="font-semibold text-crimson underline"
                      to={`/admin/requests/${item.requestId}`}
                    >
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && !error ? (
            <p className="mt-4 text-charcoal/80">No feedback requests yet.</p>
          ) : null}
        </div>
      </section>
    </PageShell>
  );
}
